import { gql } from '@apollo/client';

export const PROPERTY_NYBYGG_FRAGMENT = gql`
  fragment PropertyNybygg on Property {
    newDevelopment {
      estatePicker {
        label
        url
      }
      showPriceList
    }
    nybygg {
      boligvelger {
        rt
        external
      }
      profile
      showPriceList
    }
  }
`;
